import { ExternalLink } from 'lucide-react';

import { Button, Card, CardContent, CardHeader } from '@/components/ui';

import { PanelTitle } from './PanelTitle';

export function TelemetryPanel() {
  return (
    <Card>
      <CardHeader>
        <PanelTitle>Telemetry</PanelTitle>
      </CardHeader>
      <CardContent className="space-y-4 pt-4">
        <p className="text-muted-foreground text-sm">
          Open the local task-system dashboard in Grafana.
        </p>
        <Button variant="outline" asChild>
          <a
            href="http://localhost:3001"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ExternalLink className="h-4 w-4" aria-hidden="true" />
            Open Grafana
          </a>
        </Button>
      </CardContent>
    </Card>
  );
}
